import * as React from "react";
import { AppRoutes } from "./routes/Routes";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CssBaseline } from "@mui/material";
import TokenHandler from "./components/sys-common/TokenHandler";

function App() {
  return (
    <BrowserRouter>
      <CssBaseline />
      <Provider store={store}>
        <TokenHandler>
          <AppRoutes />
          <ToastContainer
            position="top-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </TokenHandler>
      </Provider>
    </BrowserRouter>
  );
}
export default App;
